<div *ngIf="loading" class="loader">
    <div class="spinner"></div>
</div>